export default "__VITE_ASSET__DXRKFkgJ__"